// Format amount with commas for thousands
export const formatAmount = (amount) => {
  return Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Get contact name from transaction (excluding 'me')
export const getContactFromTransaction = (tx) => {
  let contact = [tx.loanedBy, tx.borrowedBy, tx.paidBy, tx.paidFor]
    .find(name => name && name.toLowerCase() !== 'me');

  // For settlements, extract contact from description if not found
  if (!contact && tx.type === 'settlement' && tx.description) {
    const match = tx.description.match(/Loan Settlement with (.+)/i);
    if (match) contact = match[1];
  }

  return contact;
};
